import { getCompressedAssetUrl } from 'lib/config/assetUrls';

const EARTH_GLOBE_ASSETS = '/web_v2/home-v4/world-sleep/earth/';

/** Bump when replacing globe snapshot, overlay, or earth maps at the same path. */
const EARTH_GLOBE_ASSET_VERSION = '4';

/** Floor at 4096 so SpeedSize does not UA-downscale; sources already ≤4050. */
const EARTH_GLOBE_TEXTURE_WIDTH = 'w_4096';

function earthGlobeSrc(src: string): string {
  const join = src.includes('?') ? '&' : '?';
  return `${src}${join}v=${EARTH_GLOBE_ASSET_VERSION}`;
}

function earthGlobeTextureUrl(file: string): string {
  return `${getCompressedAssetUrl(
    earthGlobeSrc(`${EARTH_GLOBE_ASSETS}${file}`),
  )}/${EARTH_GLOBE_TEXTURE_WIDTH}`;
}

export const EARTH_GLOBE_SNAPSHOT_SRC = earthGlobeSrc(
  'web_v2/home-v4/world-sleep/globe-snapshot.webp',
);

export const EARTH_GLOBE_OVERLAY_SRC = getCompressedAssetUrl(
  earthGlobeSrc('/web_v2/home-v4/world-sleep/globe-overlay.svg'),
);

export const EARTH_GLOBE_TEXTURE_URLS = [
  earthGlobeTextureUrl('spec-map.webp'),
  earthGlobeTextureUrl('clouds.webp'),
  earthGlobeTextureUrl('night-lights.webp'),
] as const;

type NetworkInformationLike = {
  saveData?: boolean;
};

function getConnection(): NetworkInformationLike | undefined {
  const nav = navigator as Navigator & {
    connection?: NetworkInformationLike;
    mozConnection?: NetworkInformationLike;
    webkitConnection?: NetworkInformationLike;
  };
  return nav.connection ?? nav.mozConnection ?? nav.webkitConnection;
}

export function shouldUseEarthGlobeWebGL(): boolean {
  if (typeof window === 'undefined') return false;
  if (getConnection()?.saveData) return false;
  return true;
}

export function prefetchEarthGlobeTextures(): void {
  if (typeof document === 'undefined') return;
  for (const url of EARTH_GLOBE_TEXTURE_URLS) {
    const existing = document.head.querySelector(
      `link[rel="preload"][href="${url}"]`,
    );
    if (existing) continue;
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = url;
    document.head.appendChild(link);
  }
}
